export default "__VITE_ASSET__bffce6e8__"